module.exports = __webpack_public_path__ + "media/img/home/product/mobile/product3-d5e903f1984d1b062b8d69b68496baae.svg";